<template>
    <div>
        <div class="d-flex" id="wrapper">
            <!-- Sidebar -->
            <SideBar/>
            <!-- /#sidebar-wrapper -->
            <!-- Page Content -->
            <div id="page-content-wrapper">
                <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                    <div>
                        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                        </button>

                        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                        </button>
                    </div>
                    <div class="d-flex">
                        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                        <p class="text-muted mb-0 hover-cursor link" @click="toProductCatalogPage">&nbsp;Warehouse</p>
                        <p class="text-muted mb-0 hover-cursor link" @click="toProductCatalogPage">&nbsp;/&nbsp;Order List</p>
                        <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;ID BAG</p>
                    </div>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  {{ admin }}
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="container-fluid mt-3">
                    <div class="row">
                        <div class="col-md-12 grid-margin stretch-card card-div">
                            <div class="container">
                                <div class="row" v-if="purpose === 'bag'">
                                    <div class="col-12">
                                        <span>Request Details</span>
                                        <div class="container mt-2">
                                            <table>
                                                <tr>
                                                    <td class="field-label" valign="top">Request ID</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">Request Date</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini PRC/20201117/1010/012 khbdhbsh kbkbkh kjbkjbkj kjbkjabdkjs kjbkjbk kjbskajbdkj kjbkjbds</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">Status</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">Support Name</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="purpose === 'ticket'">
                                    <div class="col-6">
                                        <span>Ticket Details</span>
                                        <div class="container mt-2">
                                            <table>
                                                <tr>
                                                    <td class="field-label" valign="top">Ticket ID</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">Status</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini </td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">Support Name</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">Trouble Shoot</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">AE Name</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <span>Lessee Details</span>
                                        <div class="container mt-2">
                                            <table>
                                                <tr>
                                                    <td class="field-label" valign="top">Name</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">Address</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini PRC/20201117/1010/012 khbdhbsh kbkbkh kjbkjbkj kjbkjabdkjs kjbkjbk kjbskajbdkj kjbkjbds</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">PIC Name</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">PIC Phone</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="purpose === 'order'">
                                    <div class="col-6">
                                        <span>Order Details</span>
                                        <div class="container mt-2 mb-2">
                                            <table>
                                                <tr>
                                                    <td class="field-label" valign="top">Order ID</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">Status</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini </td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">Delivery Est.</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                            </table>
                                        </div>
                                        <span>AE Details</span>
                                        <div class="container mt-2">
                                            <table>
                                                <tr>
                                                    <td class="field-label" valign="top">AE Name</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">AE Phone</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <span>Lessee Details</span>
                                        <div class="container mt-2">
                                            <table>
                                                <tr>
                                                    <td class="field-label" valign="top">Name</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">Address</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini PRC/20201117/1010/012 khbdhbsh kbkbkh kjbkjbkj kjbkjabdkjs kjbkjbk kjbskajbdkj kjbkjbds</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">PIC Name</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                                <tr>
                                                    <td class="field-label" valign="top">PIC Phone</td>
                                                    <td style="width: 10px" valign="top">:</td>
                                                    <td>ini nama</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <table class="table table-sm table-bordered table-striped table-responsive-sm w-100 mt-4">
                                    <thead class="">
                                        <tr>
                                            <th>Item Name</th>
                                            <th>Qty</th>
                                            <th class="action-width">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="loadingLog === false && totalData == '1'">
                                            <td colspan="6" class="text-center">Data Not Available</td>
                                        </tr>
                                        <tr v-else-if="loadingLog === true">
                                            <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                        </tr>
                                        <tr v-for="(data,index) in [1,2,3,4]" :key="`key-${index}`" v-else>
                                            <td>1</td>
                                            <td>2</td>
                                            <td class="text-center">
                                                <button class="btn btn-sm btn-primary" @click="openModal('Assign', 'Sparepart')">Assign</button>
                                                <button class="btn btn-sm btn-primary" @click="openModal('Change', 'Sparepart')">Change</button>
                                                <button class="btn btn-sm btn-danger" @click="openModal('RejectItem', 'Product')">Reject</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="table table-sm table-bordered table-striped table-responsive-sm" style="margin-top: -41px; margin-left: 112px; width: 90%;">
                                    <thead class="">
                                        <tr>
                                            <th>SKU</th>
                                            <th>Name</th>
                                            <th class="action-width">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="loadingLog === false && totalData == '1'">
                                            <td colspan="6" class="text-center">Data Not Available</td>
                                        </tr>
                                        <tr v-else-if="loadingLog === true">
                                            <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                        </tr>
                                        <tr v-for="(data,index) in [1,2,3,4]" :key="`k-${index}`" v-else>
                                            <td>1</td>
                                            <td>2</td>
                                            <td class="text-center">
                                                <button class="btn btn-sm btn-danger" @click="openModal('Cancel', 'Sparepart')">Cancel</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- For PRoduct -->
                                <table class="table table-sm table-bordered table-striped table-responsive-sm w-100">
                                    <thead class="">
                                        <tr>
                                            <th>Item Name</th>
                                            <th>Qty</th>
                                            <th class="action-width">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="loadingLog === false && totalData == '1'">
                                            <td colspan="6" class="text-center">Data Not Available</td>
                                        </tr>
                                        <tr v-else-if="loadingLog === true">
                                            <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                        </tr>
                                        <tr v-for="(data,index) in [1,2,3,4]" :key="`productKey-${index}`" v-else>
                                            <td>1</td>
                                            <td>2</td>
                                            <td class="text-center">
                                                <button class="btn btn-sm btn-primary" @click="openModal('Assign', 'Product')">Assign</button>
                                                <button class="btn btn-sm btn-primary" @click="openModal('Change', 'product')">Change</button>
                                                <button class="btn btn-sm btn-danger" @click="openModal('RejectItem', 'Product')">Reject</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="table table-sm table-bordered table-striped table-responsive-sm" style="margin-top: -41px; margin-left: 112px; width: 90%;">
                                    <thead class="">
                                        <tr>
                                            <th>Stock Code</th>
                                            <th>Serial Number</th>
                                            <th>Actual Specification</th>
                                            <th class="action-width">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="loadingLog === false && totalData == '1'">
                                            <td colspan="6" class="text-center">Data Not Available</td>
                                        </tr>
                                        <tr v-else-if="loadingLog === true">
                                            <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                        </tr>
                                        <tr v-for="(data,index) in [1,2,3,4]" :key="`pkey-${index}`" v-else>
                                            <td>1</td>
                                            <td>2</td>
                                            <td>3</td>
                                            <td class="text-center">
                                                <button class="btn btn-sm btn-danger" @click="openModal('Cancel', 'Product')">Cancel</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="table table-sm table-bordered table-striped table-responsive-sm w-100">
                                    <thead class="">
                                        <tr>
                                            <th>Date</th>
                                            <th>Action</th>
                                            <th>Executor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="loadingLog === false && totalData == '1'">
                                            <td colspan="6" class="text-center">Data Not Available</td>
                                        </tr>
                                        <tr v-else-if="loadingLog === true">
                                            <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                        </tr>
                                        <tr v-for="(data,index) in [1,2,3,4]" :key="`nKey-${index}`" v-else>
                                            <td>1</td>
                                            <td>2</td>
                                            <td>3</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="d-flex justify-content-end">
                                    <button class="btn btn-danger" @click="openModal('RejectRequest')">Reject Request</button>
                                    <button class="btn btn-success ml-1" @click="openModal('Finish', '')">Finish & Handover</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /#page-content-wrapper -->
            <div class="modal fade" id="modalRejectItem" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Reject Item</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure to reject this requested item?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitAddProduct('draft')">Yes, Sure</button>
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Yes, Sure</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modalRejectRequest" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Reject Request</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure to reject this request?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitAddProduct('draft')">Yes, Sure</button>
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Yes, Sure</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modalAssign" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Assigning {{itemTypeChoose}}</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body" v-if="itemTypeChoose.toLowerCase() == 'sparepart'">
                            <span>Are you sure to assign out this item:</span>
                            <div class="ml-3 mt-2">
                                <table>
                                    <tr>
                                        <td style="width: 100px">SKU</td>
                                        <td style="width: 10px">:</td>
                                        <td>ini SKU</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100px">Name</td>
                                        <td style="width: 10px">:</td>
                                        <td>ini SKU</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100px">Qty</td>
                                        <td style="width: 10px">:</td>
                                        <td>1 Unit</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="modal-body" v-if="itemTypeChoose.toLowerCase() == 'product'">
                            <span>Are you sure to assign product bellow:</span>
                            <div class="ml-3 mt-2">
                                <table>
                                    <tr>
                                        <td style="width: 100px">Name</td>
                                        <td style="width: 10px">:</td>
                                        <td>ini SKU</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100px">Catalog Spec</td>
                                        <td style="width: 10px">:</td>
                                        <td>ini SKU</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100px">Qty</td>
                                        <td style="width: 10px">:</td>
                                        <td>1 Unit</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="mt-2">
                                <div class="d-flex">
                                    <span style="width: 210px;" class="align-self-center">1 of 2 Units : </span>
                                    <input type="text" name="scSn" class="form-control text-field" placeholder="SC / SN">
                                    <button class="btn btn-primary ml-2">Get</button>
                                </div>
                                <div class="container">
                                    <div class="d-flex mt-2">
                                        <div class="field-label-one align-self-center">Name</div>
                                        <input type="text" name="name" disabled class="form-control text-field">
                                    </div>
                                    <div class="d-flex mt-2">
                                        <div class="field-label-one align-self-center">Actual Spec</div>
                                        <input type="text" name="name" disabled class="form-control text-field">
                                    </div>
                                    <div class="d-flex mt-2">
                                        <div class="field-label-one align-self-center">Serial Number</div>
                                        <input type="text" name="name" disabled class="form-control text-field">
                                    </div>
                                    <div class="d-flex mt-2">
                                        <div class="field-label-one align-self-center">Stock Code</div>
                                        <input type="text" name="name" disabled class="form-control text-field">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitAddProduct('draft')">Yes, Sure</button>
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Yes, Sure</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modalChange" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Change {{itemTypeChoose}}</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body" v-if="itemTypeChoose.toLowerCase() == 'sparepart'">
                            <span>Requested Sparepart : </span>
                            <div class="ml-3 mt-2">
                                <table>
                                    <tr>
                                        <td style="width: 100px">SKU</td>
                                        <td style="width: 10px">:</td>
                                        <td>ini SKU</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100px">Name</td>
                                        <td style="width: 10px">:</td>
                                        <td>ini SKU</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100px">Qty</td>
                                        <td style="width: 10px">:</td>
                                        <td>1 Unit</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="d-flex mt-2">
                                <span class="align-self-center" style="width: 405px">Replacement Sparepart : </span>
                                <input type="text" name="sku" class="form-control text-field" placeholder="Sparepart SKU">
                                <button class="btn btn-primary ml-2">Get</button>
                            </div>
                            <div class="container">
                                <div class="ml-3 mt-2">
                                    <table class="w-100">
                                        <tr>
                                            <td style="width: 100px">Name</td>
                                            <td style="width: 10px">:</td>
                                            <td>
                                                <input type="text" name="sparepart" class="form-control text-field mb-2" placeholder="Sarepart Name" disabled>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="width: 100px">Qty</td>
                                            <td style="width: 10px">:</td>
                                            <td>
                                                <input type="number" name="qty" class="form-control text-field" placeholder="Quantity" disabled>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="modal-body" v-if="itemTypeChoose.toLowerCase() == 'product'">
                            <span>Requested Product :</span>
                            <div class="ml-3 mt-2">
                                <table>
                                    <tr>
                                        <td style="width: 100px">SKU</td>
                                        <td style="width: 10px">:</td>
                                        <td>ini SKU</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100px">Name</td>
                                        <td style="width: 10px">:</td>
                                        <td>ini SKU</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100px">Catalog Spec</td>
                                        <td style="width: 10px">:</td>
                                        <td>ini SKU</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 100px">Qty</td>
                                        <td style="width: 10px">:</td>
                                        <td>1 units</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="mt-2">
                                <span>Replacement Product :</span>
                                <div class="container">
                                    <div class="d-flex mt-2">
                                        <div class="field-label-one align-self-center">Name</div>
                                        <multiselect v-model="searchType" :options="productType" label="productTypeName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Product Type" track-by="productTypeName"></multiselect>
                                    </div>
                                    <div class="d-flex mt-2">
                                        <div class="field-label-one align-self-center">Catalog Spec</div>
                                        <multiselect v-model="searchType" :options="productType" label="productTypeName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Product Type" track-by="productTypeName"></multiselect>
                                    </div>
                                    <div class="d-flex mt-2">
                                        <div class="field-label-one align-self-center">Qty</div>
                                        <input type="number" name="name" disabled class="form-control text-field">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitAddProduct('draft')">Change</button>
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Change</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modalFinish" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Finish & Handover</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure all the requested item already prepared and ready to be handovered to Support ?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitAddProduct('draft')">Yes, Sure</button>
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Yes, Sure</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
export default {
    name: 'ProductAddPage',
    components: {
        SideBar,
        Multiselect
    },
    data() {
        return {
            spaceRegex: /[\u00A0\uFEFF\u202F]/g, 
            admin: "",
            permission: [],
            viewDashboard: false,
            viewOrder: false,
            viewReturn: false,
            viewProduct: false,
            viewPairing: false,
            viewReconcile: false,
            viewResolution: false,
            viewLessor: false,
            viewLessee: false,
            viewEmployee: false,
            editOrder: false,
            editReturn: false,
            editProduct: false,
            editPairing: false,
            editReconcile: false,
            editResolution: false,
            editLessor: false,
            editLessee: false,
            editEmployee: false,
            loadingButtonProcess: false,
            loadingLog:false,
            dataOrder: [],
            totalPage: 0,
            totalData: 0,
            currentPage: 1,
            orderId: "",
            companyName: "",
            statusOrder: "",
            productCategory: [],
            productType: [],
            productBrand: [],
            addCategory: [],
            productDuration: [[]],
            productDisplayType: ['LCD', 'LED'],
            productVGA: ['Tersedia', 'Tidak Ada'],
            productDVID: ['Tersedia', 'Tidak Ada'],
            productHDMI: ['Tersedia', 'Tidak Ada'],

            addType: [],
            addBrand: '',
            addModel: '',
            addScreen: '',
            addProcessor: '',
            addRam: '',
            addStorage: [],
            addStorageSmartphone: [],
            addVGA: '',
            mainCamera: '',
            frontCamera: '',

            addDisplaySize: '',
            addDisplayType: '',
            addPortVga: '',
            addPortDvid: '',
            addPortHdmi: '',
            addColorTech: '',
            AddFeature: '',
            addBattery:'',

            addSpecifications:'',
            addDescription: '',
            addDuration: [''],
            newDuration: [''],
            durationPrice: [''],
            newDurationPrice: [''],
            depositPrice: [''],
            insurancePrice: [''],
            addPhoto: [],
            imgFile: '',
            imgFileName: '',
            imgBase64: '',
            imgUrl: '',
            newBrand: '',
            storageType: 'SSD',
            storageTypeSmartphone: 'EMMC',
            tenor: [1],
            plusIdx: 0,
            duration: [],
            newCategory: '',
            durationValue:[],
            conditionProduct:[{
                status:'1',
                statusName:'New'
            }],
            productCondition:[{
                status:'1',
                statusName:'New'
            },{
                status:'2',
                statusName:'Refurbished'
            }],
            temp:[],
            statusProduct:[{
                status:'1',
                statusName:'Active'
            }],
            productStatus:[{
                status:'1',
                statusName:'Active'
            },{
                status:'0',
                statusName:'Inactive'
            }],
            productChoose:[1],
            dataLog:[1],
            pageAction:'',
            itemTypeAdd:[],
            idProcure:'',
            itemTypeChoose:'',
            purpose:''
        }
    },
    methods: {
        capitalFirstChar(string){
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        toAddItemPage(id) {
            this.$router.push({path:'/procure/detail/' + this.idProcure + '/add',
                query: {
                    productType: id
                }
            })
        },
        pickFile(ref){
            this.$refs[ref].click()
        },
        toProductCatalogPage(){
          this.$router.push({path:'/product',
                query: {
                    productType: 'All',
                    productTypeName: 'All',
                    productCategory: 'All',
                    productBrand: 'All',
                    productStatus: 'All',
                    productStatusName: 'All',
                    productName: '',
                    itemPerPage: 10,
                    page:1
                }
            })
        },
        updateDuration(pilih,index){
            if (pilih == 'condition') {
                for (var i = 0; i < this.conditionProduct.length; i++) {
                    if (i!=index) {
                       if (this.conditionProduct[index].status == this.conditionProduct[i].status && this.addDuration[index] == this.addDuration[i]) {
                            this.addDuration[index]=''
                       } 
                    } 
                }
            }
            for (var i = 0; i < this.conditionProduct.length; i++) {
                this.productDuration[i]=[]
                var arrayNew = []
                var arrayRef = []
                for (var k = 0; k < this.temp.length; k++) {
                    arrayNew.push(this.temp[k])
                    arrayRef.push(this.temp[k])
                }
                
                for (var j = 0; j < this.conditionProduct.length; j++) {
                    if (i!=j) {
                        if (this.addDuration[j] != 'Other') {
                            if (this.conditionProduct[i].status == 1) {
                                if (this.conditionProduct[i].status == this.conditionProduct[j].status) {
                                    var index = arrayNew.indexOf(this.addDuration[j]);
                                    if (index !== -1) arrayNew.splice(index, 1);
                                }
                            }else{
                                if (this.conditionProduct[i].status == this.conditionProduct[j].status) {
                                    var index = arrayRef.indexOf(this.addDuration[j]);
                                    if (index !== -1) arrayRef.splice(index, 1);
                                }
                            }
                        }
                    }
                }
                if (this.conditionProduct[i].status == 1) {
                    for (var l = 0; l < arrayNew.length; l++) {
                        this.productDuration[i].push(arrayNew[l])
                    }
                }else{
                    for (var l = 0; l < arrayRef.length; l++) {
                        this.productDuration[i].push(arrayRef[l])
                    }
                }               
            }
        },
        addRowProduct(count) {
            this.productChoose.push(count+1)    
        },
        addRow(x) {
                if (this.cekDuration() == 0) {
                    this.plusIdx = this.plusIdx + 1
                    this.addDuration.push('')

                    this.durationPrice.push('')
                    this.newDuration.push('')
                    this.newDurationPrice.push('')
                    this.depositPrice.push('')
                    this.insurancePrice.push('')
                    this.tenor.push(x+1)
                    this.conditionProduct.push({
                        status:'1',
                        statusName:'New'
                    })
                    this.statusProduct.push({
                        status:'1',
                        statusName:'Active'
                    })
                    this.updateDuration()
                }
            },
            validationField(x) {
                if (this.addType == null || this.addType == '') {
                    swal("Sorry", "Product type must be select", "error", {
                        button: "Ok",
                    })
                } else if (this.cekCategory() != 0) {
                    swal("Sorry", "Product Category must be fill", "error", {
                        button: "Ok",
                    })
                } else if (this.addBrand == '') {
                    swal("Sorry", "Product Brand must be select", "error", {
                        button: "Ok",
                    })
                } else if (this.addBrand == 'Other') {
                    if (this.newBrand == '') {
                        swal("Sorry", "New Brand must be fill", "error", {
                            button: "Ok",
                        })
                    } else if (this.cekBottomofBrand(this.addType.productType) != 0) {

                    } else if (this.cekDuration() != 0) {
                        swal("Sorry", "Product Duration or price or deposit must be fill", "error", {
                            button: "Ok",
                        })
                    } else {
                        this.openModal(x)
                    }
                } else if (this.cekBottomofBrand(this.addType.productType) != 0) {

                } else if (this.cekDuration() != 0) {
                    swal("Sorry", "Product Duration or price or deposit must be fill", "error", {
                        button: "Ok",
                    })
                } else {
                    this.openModal(x)
                }
            },
            cekCategory: function() {
                var kosong = 0
                if (this.addType.productType<7) {
                    if (this.addCategory.productCategory == '' || this.addCategory.productCategory == null) {
                        kosong = kosong + 1
                    } else if (this.addCategory.productCategory == 'Other') {
                        if (this.newCategory == '') {
                            kosong = kosong + 1
                        }
                    }  
                }
                return kosong
            },
            cekDuration: function() {
                var kosong = 0
                for (var i = 0; i < this.addDuration.length; i++) {
                    if (this.addDuration[i] != 'Other' && (this.addDuration[i] == '' || this.durationPrice[i] == '' || this.durationPrice[i] == '0' || this.depositPrice[i] == '' || this.insurancePrice[i] == '')) {
                        kosong = kosong + 1
                    } else if (this.addDuration[i] == 'Other') {
                        if (this.newDuration[i] == '' || this.newDuration[i] == '0' || this.newDurationPrice[i] == '' || this.newDurationPrice[i] == '0' || this.depositPrice[i] == '' || this.insurancePrice[i] == '') {
                            kosong = kosong + 1
                        }
                    }
                }
                return kosong
            },
            cekBottomofBrand: function(type) {
                var salah = 0
                if (type == 1 || type == 2) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addScreen == '') {
                        swal("Sorry", "Product Screen must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addProcessor == '') {
                        swal("Sorry", "Product Processor must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addRam == '') {
                        swal("Sorry", "Product RAM must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.storageType == 'HDD+SSD') {
                        if (this.addStorage[0] == '' || this.addStorage[0] == null) {
                            swal("Sorry", "Product Storage must be fill", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        }else if (this.addStorage[1] == '' || this.addStorage[1] == null) {
                            swal("Sorry", "Product Storage must be fill", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        }else if (this.addVGA == '') {
                            swal("Sorry", "Product VGA must be fill", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        } else if (this.cekFoto() == 6) {
                            swal("Sorry", "Product Foto minimum 1", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        }
                    } else if (this.addStorage == '') {
                        swal("Sorry", "Product Storage must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addVGA == '') {
                        swal("Sorry", "Product VGA must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                }else if (type == 5 || type == 6) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addScreen == '') {
                        swal("Sorry", "Product Screen must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addProcessor == '') {
                        swal("Sorry", "Product Processor must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addRam == '') {
                        swal("Sorry", "Product RAM must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addStorageSmartphone == '') {
                        swal("Sorry", "Product Storage must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addBattery == '') {
                        swal("Sorry", "Product Battery must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }else if (this.AddFeature == '') {
                        swal("Sorry", "Product Feature must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                } else if (type == 3) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addDisplaySize == '') {
                        swal("Sorry", "Display Size must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addDisplayType == '') {
                        swal("Sorry", "Display Type must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addPortVga == '') {
                        swal("Sorry", "Port VGA must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addPortDvid == '') {
                        swal("Sorry", "Port DVI-D must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addPortHdmi == '') {
                        swal("Sorry", "Port HDMI must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                } else if (type == 4) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addColorTech == '') {
                        swal("Sorry", "Color Technology must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.AddFeature == '') {
                        swal("Sorry", "Feature must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                } else {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addScreen == '' && this.addType.productType < 7) {
                        swal("Sorry", "Product Screen must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }else if (this.addSpecifications == '' && this.addType.productType > 6) {
                        swal("Sorry", "Product specifications must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                }
                return salah
            },
            cekFoto: function() {
                var kosong = 6
                for (var i = 0; i < 6; i++) {
                    if (this.addPhoto[i].imgFileName != '') {
                        kosong = kosong - 1
                    }
                }
                return kosong
            },
            submitAddProduct(x) {
                var self = this
                this.loadingButtonProcess = true
                if (this.addBrand == 'Other') {
                    this.addBrand = this.newBrand
                }
                if (this.addCategory.productCategory == 'Other') {
                    this.addCategory.productCategory = this.newCategory
                }
                for (var i = 0; i < this.addDuration.length; i++) {
                    if (this.addDuration[i] == 'Other') {
                        this.durationValue[i] = this.newDuration[i]
                        this.durationPrice[i] = this.newDurationPrice[i]
                    } else {
                        this.durationValue[i] = this.addDuration[i]
                    }
                }
                if (this.addType.productType == 1 || this.addType.productType == 2) {
                    var storage
                    if (this.storageType == 'HDD+SSD') {
                        storage = this.addStorage[0] +'GB HDD , ' + this.addStorage[1] +'GB SSD'
                    }else{
                        storage = this.addStorage[0] + 'GB ' + this.storageType
                    }
                    var details = {
                        brand: this.addBrand.replace(this.spaceRegex,' '),
                        model: this.addModel.replace(this.spaceRegex,' '),
                        screen: this.addScreen.toString().replace(this.spaceRegex,' '),
                        processor: this.addProcessor.replace(this.spaceRegex,' '),
                        ram: this.addRam.toString().replace(this.spaceRegex,' '),
                        storage: storage,
                        vga: this.addVGA.replace(this.spaceRegex,' ')
                    }
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            condition:this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.ADD_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                } else if (this.addType.productType == 3) {
                    var details = {
                        brand: this.addBrand.replace(this.spaceRegex,' '),
                        model: this.addModel.replace(this.spaceRegex,' '),
                        displaySize: this.addDisplaySize.toString().replace(this.spaceRegex,' '),
                        displayType: this.addDisplayType.replace(this.spaceRegex,' '),
                        portVga: this.addPortVga.replace(this.spaceRegex,' '),
                        portDvid: this.addPortDvid.replace(this.spaceRegex,' '),
                        portHdmi: this.addPortHdmi.replace(this.spaceRegex,' ')
                    }
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            condition:this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.ADD_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                } else if (this.addType.productType == 4) {
                    var details = {
                        brand: this.addBrand.replace(this.spaceRegex,' '),
                        model: this.addModel.replace(this.spaceRegex,' '),
                        colorTech: this.addColorTech.replace(this.spaceRegex,' '),
                        feature: this.AddFeature.replace(this.spaceRegex,' ')
                    }
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            condition:this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.ADD_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription.replace(this.spaceRegex,' '),
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                } else if (this.addType.productType == 5 || this.addType.productType == 6) {
                    var storage = this.addStorageSmartphone[0] + 'GB '
                    var details = {
                        brand: this.addBrand.replace(this.spaceRegex,' '),
                        model: this.addModel.replace(this.spaceRegex,' '),
                        screen: this.addScreen.toString().replace(this.spaceRegex,' '),
                        processor: this.addProcessor.replace(this.spaceRegex,' '),
                        ram: this.addRam.toString().replace(this.spaceRegex,' '),
                        storage: storage,
                        mainCamera: this.mainCamera.replace(this.spaceRegex,' '),
                        frontCamera: this.frontCamera.replace(this.spaceRegex,' '),
                        battery : this.addBattery.replace(this.spaceRegex,' '),
                        feature : this.AddFeature.replace(this.spaceRegex,' ')
                    }
                    
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            condition:this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.ADD_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription.replace(this.spaceRegex,' '),
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                }else {
                    var details={}
                    if (this.addType.productType < 7){
                        details = {
                            brand: this.addBrand.replace(this.spaceRegex,' '),
                            model: this.addModel.replace(this.spaceRegex,' '),
                            screen: this.addScreen.toString().replace(this.spaceRegex,' ')
                        }
                    }else{
                        details = {
                            brand: this.addBrand,
                            model: this.addModel,
                            specifications: this.addSpecifications
                        }
                    }
                    
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            tenorMonths: this.durationValue[i],
                            depositPrice:this.depositPrice[i],
                            price: this.durationPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            condition:this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.ADD_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription.replace(this.spaceRegex,' '),
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                }
            },
            openModal(modalName, typeChoose) {
                $("#modal" + modalName).modal('show')
                this.itemTypeChoose = typeChoose
            },
            toPage(e) {
                this.$router.push(e)
            },
            async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
                localStorage.removeItem('jwt')
                localStorage.removeItem('admin_name')
                localStorage.removeItem('roles')
                localStorage.removeItem('user_email')
                localStorage.removeItem('admin_id')
                localStorage.removeItem('changeCatalogPermission')
                this.$router.push('/')
            },
            cekLogin() {
                if (localStorage.getItem('jwt') == null) {
                    this.$router.push('/')
                }
            },
            cekPermission() {
                this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
                for (var i = 0; i < this.permission.length; i++) {
                    if (this.permission[i] == "1") {
                        this.viewDashboard = true
                    }
                    if (this.permission[i] == "2.1") {
                        this.viewOrder = true
                    }
                    if (this.permission[i] == "2.2") {
                        this.editOrder = true
                    }
                    if (this.permission[i] == '3.1') {
                        this.viewReturn = true
                    }
                    if (this.permission[i] == '3.2') {
                        this.editReturn = true
                    }
                    if (this.permission[i] == '4.1') {
                        this.viewProduct = true
                    }
                    if (this.permission[i] == '4.2') {
                        this.editProduct = true
                    }
                    if (this.permission[i] == '5.1') {
                        this.viewPairing = true
                    }
                    if (this.permission[i] == '5.2') {
                        this.editPairing = true
                    }
                    if (this.permission[i] == '6') {
                        this.viewReconcile = true
                    }
                    if (this.permission[i] == '7.1') {
                        this.viewResolution = true
                    }
                    if (this.permission[i] == '7.2') {
                        this.editResolution = true
                    }
                    if (this.permission[i] == '8.1') {
                        this.viewLessor = true
                    }
                    if (this.permission[i] == '8.2') {
                        this.editLessor = true
                    }
                    if (this.permission[i] == '9.1') {
                        this.viewLessee = true
                    }
                    if (this.permission[i] == '9.2') {
                        this.editLessee = true
                    }
                    if (this.permission[i] == '10') {
                        this.viewEmployee = true
                    }
                }
                if (this.editProduct == false) {
                    this.$router.push('/')
                }
            },
            sidebar() {
                $("#wrapper").toggleClass("toggled");
            },
            removeImage(index) {
                this.addPhoto[index - 1] = {
                    imgFileName: '',
                    imgBase64: ''
                }
                document.getElementById("file_img_" + index).value = "";
                document.getElementById("show_img_" + index).src = 'https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg';
            },
            onFilePicked(e, index) {
                const files = e.target.files
                if (files[0] !== undefined) {
                    this.imgFileName = files[0].name
                    if (this.imgFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.imgUrl = fr.result
                        this.imgFile = files[0] // this is an image file that can be sent to server...
                        this.imgBase64 = fr.result.split("base64,")[1]
                        if (this.imgFileName.toLowerCase().includes(".png")) {
                            if (this.imgFile.size >= 2000000) {
                                this.imgFileName = ''
                                this.imgFile = ''
                                this.imgUrl = ''
                                swal("Ukuran file tidak boleh lebih dari 2MB", "", "warning", {
                                        buttons: {
                                            agree: "OK",
                                        },
                                    })
                                    .then((value) => {
                                        // this.pickFile()
                                    });
                            } else {
                                var fuData = document.getElementById('file_img_' + index);
                                var FileUploadPath = fuData.value;
                                var reader = new FileReader();
                                reader.onload = function(e) {
                                    $('#show_img_' + index).attr('src', e.target.result);
                                }
                                reader.readAsDataURL(fuData.files[0]);
                                this.addPhoto[index - 1] = {
                                    imgFileName: this.imgFileName,
                                    imgBase64: this.imgBase64
                                }
                            }
                        } else {
                            alert("Photo only allows file types of PNG. ");
                            document.getElementById("file_img_" + index).value = "";
                            document.getElementById("show_img_" + index).src = 'https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg';
                        }
                    })
                } else {
                    this.imgFileName = ''
                    this.imgFile = ''
                    this.imgUrl = ''
                }
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            getData() {
                this.idProcure = this.$route.params.id
                this.purpose = this.$route.query.purpose
                this.loadingLog = true
                this.$http.get(process.env.GET_CATEGORY_ADD, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                        } else {
                            this.productType = response.data.content.productType
                            this.productCategory = response.data.content.productCategory
                            this.productCategory.push({
                                productCategory: 'Other'
                            })

                            this.productBrand = Object.values(response.data.content.productBrand)
                            for (var i = 0; i < response.data.content.productDuration.length; i++) {
                                this.productDuration[0].push(response.data.content.productDuration[i])
                                this.temp.push(response.data.content.productDuration[i])
                            }
                            
                            this.productBrand.push('Other')
                            this.temp.push('Other')
                            this.productDuration[0].push('Other')
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
                this.loadingLog = false
            },
            sendLog(x){
                var today = new Date();
                var month = today.getMonth()+1
                if (month < 10) {
                    month = '0'+month
                }
                var dateDay = today.getDate()
                if (dateDay < 10) {
                    dateDay = '0'+dateDay
                }
                var hours = today.getHours()
                if (hours < 10) {
                    hours = '0'+hours
                }
                var minutes = today.getMinutes()
                if (minutes < 10) {
                    minutes = '0'+minutes
                }
                var second = today.getSeconds()
                if (second < 10) {
                    second = '0'+second
                }
                var date = today.getFullYear()+'-'+month+'-'+dateDay;
                var time = hours + ":" + minutes + ":" + second;
                var dateTime = date+' '+time;
                var admin = this.admin
                var command = 'add-logs'
                let productName = ''
                if (this.addBrand == 'Other') {
                    productName  = this.newBrand+' '+this.addModel
                }else{
                    productName  = this.addBrand+' '+this.addModel
                }
                this.$http.post(process.env.LOG_URL+"/product/"+x,{
                    codeLogs: 28,
                    params: [productName.replace(this.spaceRegex,' ')],
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                })
                .catch(error => {
                    console.log(error)
                })
            }
    },
    created() {
        for (var i = 0; i < 6; i++) {
            this.addPhoto.push({
                imgFileName: '',
                imgBase64: ''
            })
        }
        this.getData()
        this.admin = localStorage.getItem('admin_name')
        this.adminId = localStorage.getItem('admin_id')
        this.cekLogin()
        this.cekPermission()
    }
} 
</script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .action-width{
        width: 220px;
    }
    .text-field {
        height: 42.2px;
    }
    .field-label{
        width: 188px;
    }
    .field-label-one{
        width: 164px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Warehouse/OrderListDetailPage.vue